// extracted by mini-css-extract-plugin
module.exports = {"container":"b49a62dc46--container--q8hN9","title":"b49a62dc46--title--ZKvqO","text":"b49a62dc46--text--dmvBI"};